const ads = [
  {
    id: 1,
    title: 'Books!',
    src: 'https://marketingweek.imgix.net/content/uploads/2017/09/06163244/price-tags_750.jpg?auto=compress,format&q=60&w=750&h=460',
    alt: 'ad-1',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat ducimus minus perspiciatis quas rem quod, maiores quos illo corporis recusandae.',
  },
  {
    id: 2,
    title: 'Anime',
    src: 'https://marketingweek.imgix.net/content/uploads/2017/09/06163244/price-tags_750.jpg?auto=compress,format&q=60&w=750&h=460',
    alt: 'ad-1',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat ducimus minus perspiciatis quas rem quod, maiores quos illo corporis recusandae.',
  },
  {
    id: 3,
    title: 'Video Games',
    src: 'https://marketingweek.imgix.net/content/uploads/2017/09/06163244/price-tags_750.jpg?auto=compress,format&q=60&w=750&h=460',
    alt: 'ad-1',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat ducimus minus perspiciatis quas rem quod, maiores quos illo corporis recusandae.',
  },
];

export default ads;
